import { DynamicTimetableCellTypeDTO } from '@model/dynamicTimeTable/DynamicTimetableCellTypeDTO';

export const iconCellValueOptions: Partial<
  Record<DynamicTimetableCellTypeDTO, string[]>
> = {
  [DynamicTimetableCellTypeDTO.ICON_GPS_TIME]: ['{'],
  [DynamicTimetableCellTypeDTO.ICON_LOW_FLOOR]: ['}'],
  [DynamicTimetableCellTypeDTO.ICON_VEHICLE_TYPE]: ['ʬ', 'ʭ', 'ʮ'],
};
